import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Anchor = forwardRef((props, ref) => {
  const passProps = {
    href: props.href,
    onMouseEnter: props.onMouseEnter,
    onClick: props.onClick,
    className: props.className,
    style: props.style,
  };

  if (props.targetBlank) {
    passProps.target = '_blank';
    passProps.rel = 'noopener noreferrer';
  }

  return (
    <a ref={ref} {...passProps}>
      {props.children}
    </a>
  );
});

Anchor.propTypes = {
  href: PropTypes.string,
  targetBlank: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Anchor.defaultProps = {
  href: '#',
  targetBlank: false,
};

export const asLink = Component => {
  const AsLinkComponent = forwardRef((props, ref) => {
    Component.propTypes = {
      ...Component.propTypes,
      asLink: PropTypes.bool,
      href: PropTypes.string,
      onMouseEnter: PropTypes.func,
      onClick: PropTypes.func,
    };

    Component.defaultProps = {
      asLink: false,
    };

    if (props.asLink) {
      const originalComponent = Component.render(props);

      return (
        <Anchor
          ref={ref}
          href={props.href}
          onMouseEnter={props.onMouseEnter}
          onClick={props.onClick}
          className={originalComponent.props.className}
          targetBlank={props.targetBlank}
          style={originalComponent.props.style}
        >
          {originalComponent.props.children}
        </Anchor>
      );
    }

    return <Component ref={ref} {...props} />;
  });

  AsLinkComponent.propTypes = {
    asLink: PropTypes.bool,
    href: PropTypes.string,
    onMouseEnter: PropTypes.func,
    onClick: PropTypes.func,
    targetBlank: PropTypes.bool,
    style: PropTypes.object,
  };

  return { ...Component, ...AsLinkComponent };
};

export default Anchor;
